/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { JobStepName } from '../models/JobStepName';
import { JobStepStatus } from '../models/JobStepStatus';

export class JobStep {
  'stepName': JobStepName;
  'status': JobStepStatus;
  /**
  * Date and time the step started.
  */
  'startTime'?: Date | null;
  /**
  * Date and time the step completed.
  */
  'endTime'?: Date | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "stepName",
      "baseName": "stepName",
      "type": "JobStepName",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "JobStepStatus",
      "format": ""
    },
    {
      "name": "startTime",
      "baseName": "startTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "endTime",
      "baseName": "endTime",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return JobStep.attributeTypeMap;
  }

  public constructor() {
  }
}



